import React, { useEffect, useState } from 'react';
import ConnectAPI from '../../../../../services/api';
import Swal from 'sweetalert2';
import { numberFormatCommaTwoFraction } from './../../../../../common/js/utils/numberFormat';
import { Button, TextArea, Select } from '@veneer/core';
import moment from 'moment';
import { ProgressIndicator } from '@veneer/core';
import { Trans } from 'react-i18next';
import { authenticationService } from '../../../../../services/context/AuthService';

const CompensationRequest = (props) => {
  const connectApi = new ConnectAPI();
  console.log(props);
  const { id } = props.match.params;
  const [orderInfo, setOrderInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [press,setpress]=useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [status, setStatus] = useState('Under Approval');
  const [oldstatus, setoldstatus]=useState();
  const [comments, setComments] = useState('');
  const { idRole } = authenticationService.currentUserValue;
  let amountTotal = 0;
  let sumTotal = 0;
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      connectApi
        .get(
          'api/Channels/CompensationStatement/order/' + id,
          '',
          dataResponseLoad
        )
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      console.log(data);
      console.log("salida------");
      const { orderResponse, orderList, pressList } = data;
      setOrderItems(orderList === undefined ? [] : orderList);
      setOrderInfo(orderResponse);
      setStatus(
        orderResponse.status === '' ? 'Under Approval' : orderResponse.status
      );
      setoldstatus(
        orderResponse.status === '' ? 'Under Approval' : orderResponse.status
      );
      setComments(orderResponse?.comments);
      setpress(pressList);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const renderStatusOptions = () => {
    const handleStatusChange = (name) => (event) => {
      console.log(event.value);
      setStatus(event.value);
    };

    let options = [];
    let selectDisable = false;
    console.log(orderInfo?.status);
    if (orderInfo?.status === 'Shipped') {
      options.push({
        value: 'Shipped',
        label: <Trans i18nKey="Shipped" />,
      });
      selectDisable = true;
    } else if (orderInfo?.status === 'Denied') {
      options.push({
        value: 'Denied',
        label: <Trans i18nKey="Denied" />,
      });
      selectDisable = true;
      // setCommentsDisable(true);
    } else if (orderInfo?.status === 'Under approval' && idRole === 8) {
      options.push(
        {
          value: 'Under Approval',
          label: <Trans i18nKey="Under Approval" />,
        },
        {
          value: 'Denied',
          label: <Trans i18nKey="Denied" />,
        },
        //{
        //  value: 'Shipped',
        //  label: <Trans i18nKey="shipped" />,
        //},
        {
          value: 'Approved',
          label: <Trans i18nKey="Approved" />,
        }
      );
    } else if(orderInfo?.status === 'Approved' && idRole === 5) {
      options.push(
        //{
        //  value: 'Denied',
        //  label: <Trans i18nKey="denied" />,
        //},
        {
          value: 'Shipped',
          label: <Trans i18nKey="Shipped" />,
        },
        //{
        //  value: 'Approved',
        //  label: <Trans i18nKey="approved" />,
        //}
      );
    }
    return (
      <div
        style={{
          width: '230px',
          // padding: '0.5% 2% ',
        }}
      >
        <Select
          label="Status"
          name="type"
          onChange={handleStatusChange()}
          options={options}
          value={[status]}
          clearIcon={false}
          disabled={selectDisable}
        ></Select>
      </div>
    );
  };

    const handleSave = (index) => {
        setIsLoading(true);
        let action="withoutChanges";
        if (orderInfo.status!=status){
          action="StatusChanged"
        }else if (orderInfo.comments!=comments){
          action="CommentUpdated";
        }
        /*if (orderInfo.comments==null && comments!=""){
          action="CommentUpdated";
        }*/
        //const action = orderInfo.status != status ? "StatusChanged" : orderInfo.comments != comments ? "CommentUpdated" : "withoutChanges";
        //if (status !== orderInfo.status) {
        if (idRole === 8) { 
            if (status === 'Approved' || status === 'Denied' || status === 'Under approval') {
            connectApi
                .post(
                    'api/Channels/orders/status',
                    {
                        idOrder: orderInfo.idOrder,
                        idCustomer: orderInfo.idCustomer,
                        comments: comments,
                        status: status,
                        oldstatus:oldstatus,
                        idEndUser: orderInfo.idEndUser,
                        action: action
                    },
                    dataResponseLoad
                )
                .catch((error) => {
                    setIsLoading(false);
                    console.log(error);
                    if (error.response?.status == 403) {
                        Swal.fire('Error ' + 403, 'Not authorized', 'error');
                    } else {
                        Swal.fire(
                            'Error ' + error?.response?.status,
                            error?.response?.data ?? '',
                            'error'
                        );
                    }
                });
        }
        //}
        }
        else if(idRole === 5){
            if (status === 'Shipped' || status === 'Approved') {
                connectApi
                    .post(
                        'api/Channels/orders/status',
                        {
                            idOrder: orderInfo.idOrder,
                            idCustomer: orderInfo.idCustomer,
                            comments: comments,
                            status: status,
                            oldstatus:oldstatus,
                            idEndUser: orderInfo.idEndUser,
                            action: action
                        },
                        dataResponseLoad
                    )
                    .catch((error) => {
                        setIsLoading(false);
                        console.log(error);
                        if (error.response?.status == 403) {
                            Swal.fire('Error ' + 403, 'Not authorized', 'error');
                        } else {
                            Swal.fire(
                                'Error ' + error?.response?.status,
                                error?.response?.data ?? '',
                                'error'
                            );
                        }
                    });
            }
        }
  };
  const dataResponseLoad = (status, data) => {
    setIsLoading(false);
    const { history } = props;
    history.goBack();
    console.log('excelente');
    // history.push({
    //   pathname: '/cpp/report/statement/order/' + data,
    //   //data: index,
    // });
    // Swal.fire('Success', 'You order -' + data + '- was created', 'success');
  };
  return orderInfo == undefined ? (
    <div>
      <h5> <Trans i18nKey="compensation_request" /> </h5>
      <br />
      <p><Trans i18nKey="channel" /></p>
      <p><Trans i18nKey="active_press_ib" /></p>
      <p><Trans i18nKey="date" /></p>
      <p><Trans i18nKey="Status" /></p>
      <br />
      {isLoading ? (
        <ProgressIndicator size={72} className="block-center" />
      ) : undefined}
    </div>
  ) : (
    <div>
      <br />

      <h4> <Trans i18nKey="compensation_request" /> - {orderInfo.endUserName} </h4>

      <br />

      <p>
        <b><Trans i18nKey="channel" />:</b> {orderInfo.customerName}
      </p>
      <p>
        <b><Trans i18nKey="active_press_ib" />: </b> 
        {
        press.map(x=>
        (x.series==orderInfo.series)?(
          <>
            <b>{x.idPress}</b>({x.classification})
          </>
        ):(<></>)
        )}
      </p>
      <p>
        <b><Trans i18nKey="date" />:</b> {moment(orderInfo.date).format('DD/MMM/YYYY')}
      </p>
      <p>
        <b><Trans i18nKey="Status" />:</b> {orderInfo.status}
      </p>
      <p>
        <b><Trans i18nKey="orderNum" />:</b> <b>{orderInfo.idOrder}</b>
      </p>
      <br />

      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered table-sm table-fit table-card-head">
          <thead>
            <tr>
              <th scope="col" className="text-center">
                PN
              </th>
              <th scope="col" className="text-center">
                <Trans i18nKey="supply" />
              </th>
              <th scope="col" className="text-center">
                <Trans i18nKey="bonusReport.price" /> (US$)
              </th>
              <th scope="col" className="text-center">
                <Trans i18nKey="quantity" />
              </th>
              <th scope="col" className="text-center">
                <Trans i18nKey="amount" /> (US$)
              </th>
            </tr>
          </thead>
          <tbody>
            {orderItems.map((row, index) => {
              sumTotal += row.total;
              amountTotal += row.quantity;
              return (
                <tr key={row.pn}>
                  <td align="right" style={{ whiteSpace: 'nowrap' }}>
                    {row.productNumber}
                  </td>
                  <td align="right">{row.productDescription}</td>
                  <td align="right">{numberFormatCommaTwoFraction(row.price)}</td>
                  <td align="right">{row.quantity}</td>
                  <td align="right">{numberFormatCommaTwoFraction(row.total)}</td>
                </tr>
              );
            })}
            <tr className='table-total'>
              <th colSpan="3" scope="row" className="text-right">
                Total:
              </th>
              <th className="text-right" scope="row">
                {amountTotal}
              </th>
              <th className="text-right" scope="row">
                {numberFormatCommaTwoFraction(sumTotal)}
              </th>
            </tr>
          </tbody>
        </table>
        <br />

        {idRole === 5 || idRole === 8 ? (
          <div
            style={{
              width: '400px',
            }}
          >
            {renderStatusOptions()}
            <br />
            <TextArea
              id="text-area-uncontrolled"
              label="Comments"
              value={comments}
              onChange={(value) => setComments(value)}
              disabled={orderInfo.status === 'Denied'}
            />
            <br />
            <Button loading={isLoading} onClick={() => handleSave()}>Save</Button>
          </div>
        ) : (
          <p><b>Comments:</b> {orderInfo.comments}</p>
        )}
        <br />
      </div>
    </div>
  );
};

export default CompensationRequest;
